export default "__VITE_ASSET__14ZzGSwU__"